<template lang="pug">
.login.d-flex.flex-column.justify-content-center.align-items-center
  div.mb-5(style="width: 340px;")
    img.w-100(src='@/assets/sidenav/upa-logo.svg')
    .text-center.alert.alert-danger(v-if="$store.getters.authenticationError")
      | เกิดข้อผิดพลาดระหว่างการเข้าสู่ระบบ
      br
      | กรุณาตรวจสอบชื่อผู้ใช้งานและรหัสผ่านอีกครั้ง
    .text-center.my-5(v-if="$store.getters.isAuthenticating")
      .spinner-border.text-white
      p.text-white.mt-3 กำลังเข้าสู่ระบบด้วยการเชื่อมต่อที่ปลอดภัย...
    form.text-center(v-else @submit.prevent="login")
      input.form-control.px-3.py-4.my-4.shadow(
        v-model="username"
        type="text" placeholder="Username" autocomplete="username")
      input.form-control.px-3.py-4.my-4.shadow(
        v-model="password"
        type="password" placeholder="Password" autocomplete="current-password")
      input.form-control.px-3.py-4.my-4.shadow(
        v-model="token"
        v-if="token !== null && !readonlyToken" type="text" placeholder="Token เข้าสู่ระบบ")
      .control
        button.btn.btn-upa-secondary.px-5(type="submit") เข้าใช้งาน
        br
        p.text-white.mt-4(style="opacity: 0.6;" v-if="token !== null && readonlyToken")
          | Token เข้าสู่ระบบของคุณคือ
          br
          small {{token}}
        button.border-0.shadow-0.mt-4.px-4.py-2(v-if="token === null" style="background: none;")
          u.text-white(style="opacity: 0.8;" @click="token = ''") ใส่ token (สำหรับเซลล์)
  div.text-white(style="opacity: 0.1;") {{buildNote}}
</template>

<script>
export default {
  data: () => ({
    username: '',
    password: '',
    token: null,
    readonlyToken: false,
  }),
  created() {
    if (this.$route.query.token) {
      this.token = this.$route.query.token;
      this.readonlyToken = true;
    }
    if (this.$route.params.forceLogout === true) {
      this.$store.commit('clearForAuthentication');
    }
    if (this.isAuthenticated) { this.navigateToRoleHomepage(); }
  },
  computed: {
    isAuthenticated() { return this.$store.getters.isAuthenticated; },
    buildNote() { return window.BUILD_NOTE; },
  },
  watch: {
    isAuthenticated(newVal) {
      if (newVal) {
        this.navigateToRoleHomepage();
      }
    },
  },
  methods: {
    navigateToRoleHomepage() {
      console.log(this.$store.getters.user.role);
      switch (this.$store.getters.user.role) {
        case 'sale':
          this.$router.push({
            name: 'sales.home',
          });
          break;
        case 'cs':
          this.$router.push({
            name: 'cs.home',
          });
          break;
        case 'admin':
          this.$router.push({
            name: 'admin.home',
          });
          break;
        default:
          console.log('role is not existed in user');
          this.$router.push({
            name: 'sales.home',
          });
          break;
      }
    },
    login() {
      this.$store.dispatch('login', {
        username: this.username,
        password: this.password,
        token: this.token,
      });
    },
  },
};
</script>

<style lang="scss">
.login {
  height: 100%;
  width: 100vw;
  background: linear-gradient(to right, #0B478B, #1C87AE);
  form {
    input.form-control {
      background-color: rgba(#ffffff, 0.2);
      color: #ffffff;
      font-size: 16px;
      height: 58px;
      border-radius: 12px;
      &::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: #ffffff;
      }
    }
  }
}
</style>
